<template>
	<div class="bg-white shadow w-full m-0 mb-0 relative">
		<div class="container mx-auto px-4">
			<div class="flex items-center justify-between py-4">
				<div>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						class="w-10 h-10 text-purple-600"
						width="76.62px"
						height="76.621px"
						viewBox="0 0 76.62 76.621"
					>
						<path
							d="M71.496,5.123c-3.346-3.346-8.135-5.114-13.849-5.114c-11.739,0-26.429,7.396-38.334,19.303
									c-8.76,8.759-15.097,18.923-17.846,28.622c-2.834,10.001-1.535,18.369,3.657,23.562c3.346,3.347,8.134,5.114,13.849,5.115
									c0.001,0,0.001,0,0.002,0c11.738,0,26.427-7.396,38.333-19.303c8.76-8.759,15.097-18.923,17.846-28.621
									C77.987,18.684,76.688,10.316,71.496,5.123z M72.267,27.867c-2.611,9.213-8.678,18.916-17.08,27.318
									C43.822,66.55,29.946,73.61,18.973,73.609c-4.901,0-8.957-1.465-11.728-4.236c-4.39-4.39-5.417-11.713-2.892-20.623
									c2.611-9.213,8.677-18.915,17.08-27.317C32.798,10.068,46.673,3.009,57.647,3.009c4.9,0,8.956,1.464,11.728,4.235
									C73.765,11.634,74.791,18.958,72.267,27.867z"
						/>
						<path
							d="M53.9,21.671c-0.908-0.81-1.895-1.484-2.771-1.904c-0.522-0.258-1-0.433-1.35-0.537c-0.348-0.108-0.571-0.146-0.571-0.146
									s0.037,0.224,0.146,0.571c0.104,0.351,0.279,0.827,0.535,1.35c0.397,0.828,1.02,1.755,1.77,2.62
									c-0.842,0.74-1.726,1.526-2.633,2.363c-1.118,1.02-2.303,2.091-3.492,3.223c-0.778-0.637-1.591-1.17-2.326-1.523
									c-0.522-0.257-1-0.432-1.351-0.536c-0.347-0.108-0.571-0.145-0.571-0.145s0.038,0.222,0.146,0.57
									c0.104,0.351,0.277,0.828,0.535,1.351c0.344,0.713,0.856,1.5,1.471,2.259c-0.719,0.677-1.444,1.364-2.163,2.072
									c-1.104,1.086-2.221,2.187-3.341,3.289c-0.734-0.584-1.49-1.077-2.179-1.408c-0.523-0.257-0.999-0.432-1.351-0.536
									c-0.348-0.108-0.57-0.146-0.57-0.146s0.037,0.223,0.145,0.57c0.104,0.352,0.278,0.828,0.537,1.351
									c0.331,0.69,0.826,1.449,1.412,2.185c-0.895,0.908-1.784,1.814-2.666,2.71c-0.805,0.821-1.584,1.646-2.352,2.462
									c-0.764-0.617-1.556-1.136-2.272-1.479c-0.522-0.259-0.999-0.433-1.351-0.536c-0.347-0.109-0.57-0.146-0.57-0.146
									s0.037,0.223,0.146,0.57c0.104,0.352,0.278,0.828,0.536,1.352c0.354,0.738,0.89,1.557,1.534,2.34
									c-1.025,1.087-2.006,2.168-2.939,3.19c-0.706,0.765-1.37,1.509-2.007,2.229c-0.859-0.741-1.778-1.354-2.6-1.749
									c-0.522-0.257-0.999-0.433-1.351-0.536c-0.347-0.108-0.569-0.145-0.569-0.145s0.036,0.223,0.146,0.569
									c0.104,0.351,0.278,0.827,0.535,1.351c0.417,0.867,1.082,1.842,1.882,2.742c-1.476,1.7-2.688,3.162-3.57,4.245
									c-1.056,1.294-1.634,2.06-1.634,2.06s0.765-0.578,2.06-1.635c1.081-0.882,2.543-2.093,4.242-3.567
									c0.898,0.8,1.872,1.466,2.741,1.883c0.523,0.257,1,0.431,1.353,0.534c0.348,0.107,0.57,0.144,0.57,0.144s-0.035-0.224-0.144-0.571
									c-0.103-0.352-0.277-0.828-0.534-1.352c-0.395-0.822-1.008-1.741-1.751-2.6c0.72-0.635,1.466-1.299,2.229-2.004
									c1.021-0.934,2.103-1.914,3.188-2.938c0.781,0.645,1.6,1.18,2.34,1.535c0.523,0.256,1,0.43,1.351,0.534
									c0.349,0.108,0.573,0.144,0.573,0.144s-0.037-0.224-0.145-0.57c-0.104-0.353-0.277-0.83-0.534-1.353
									c-0.344-0.718-0.862-1.51-1.481-2.271c0.816-0.77,1.64-1.545,2.461-2.352c0.894-0.88,1.8-1.771,2.707-2.664
									c0.735,0.587,1.494,1.083,2.186,1.413c0.522,0.256,1,0.431,1.351,0.535c0.35,0.106,0.571,0.144,0.571,0.144
									s-0.035-0.224-0.145-0.572c-0.103-0.352-0.276-0.828-0.533-1.352c-0.33-0.689-0.823-1.445-1.408-2.179
									c1.103-1.119,2.202-2.236,3.287-3.339c0.707-0.719,1.394-1.442,2.07-2.161c0.757,0.614,1.544,1.129,2.259,1.471
									c0.521,0.257,0.999,0.431,1.352,0.534c0.348,0.108,0.571,0.144,0.571,0.144s-0.037-0.224-0.145-0.572
									c-0.104-0.351-0.277-0.828-0.533-1.351c-0.354-0.736-0.888-1.549-1.525-2.326c1.132-1.189,2.203-2.373,3.222-3.491
									c0.838-0.906,1.622-1.79,2.36-2.631c0.864,0.752,1.791,1.374,2.62,1.771c0.522,0.256,0.999,0.431,1.352,0.534
									c0.349,0.108,0.571,0.144,0.571,0.144s-0.036-0.223-0.145-0.571c-0.104-0.352-0.277-0.829-0.533-1.352
									c-0.42-0.877-1.096-1.861-1.908-2.767c1.316-1.526,2.403-2.84,3.214-3.835c1.057-1.294,1.632-2.06,1.632-2.06
									s-0.765,0.578-2.06,1.632C56.74,19.267,55.424,20.356,53.9,21.671z"
						/>
						<path
							d="M68.085,9.214c-0.351-0.35-0.479-0.479-0.485-0.487c-0.101-0.099-0.216-0.216-0.355-0.355
									c-3.364-3.365-13.75-2.616-13.75-2.616l17.73,17.73c0,0-0.221-11.354-2.695-13.83C68.351,9.478,68.206,9.334,68.085,9.214z"
						/>
						<path
							d="M8.083,67.531c0.14,0.141,0.257,0.256,0.355,0.355c0.01,0.009,0.138,0.137,0.487,0.486
									c0.12,0.121,0.265,0.266,0.443,0.443c2.476,2.477,13.828,2.697,13.828,2.697L5.468,53.783C5.468,53.783,4.719,64.167,8.083,67.531
									z"
						/>
					</svg>
				</div>

				<div class="flex items-center flex-col">
					{{ title }}
					<div class="text-sm gray-300">
						Room Code: {{ code }}
					</div>
				</div>

				<div>
					<a
						href="#"
						class="text-gray-800 text-sm font-semibold border px-4 py-2 rounded-lg hover:text-purple-600 hover:border-purple-600 relative flex items-center"
					>
						<span
							v-if="isMyTurn"
							class="absolute -top-2 -left-1.5 h-6 w-6"
						>
							<span
								class="animate-ping absolute inline-flex h-full w-full rounded-full bg-purple-400 opacity-75 -left-1.5 -top-0.5"
							></span>
							<span
								class="relative inline-flex rounded-full h-3 w-3 bg-purple-500"
							></span>
						</span>
						<div v-if="isCommissioner" class="mr-1">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								height="1rem"
								viewBox="0 0 640 512"
							>
								<path
									d="M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z"
								/>
							</svg>
						</div>
						{{ username }}
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
	computed: {
		...mapState(['current_picker', 'current_round']),
		...mapState({
			title: state => state.room.title,
			code: state => state.room.code,
			rounds: state => state.room.rounds,
			username: state => state.user.name,
			isCommissioner: state => state.user.isCommissioner,
		}),
		...mapGetters(['hasDraftStarted', 'isMyTurn']),
	},
};
</script>
